"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLessonsApi = void 0;
/* eslint-disable import/prefer-default-export */
var customLessonsApi_1 = require("./customLessonsApi");
Object.defineProperty(exports, "CustomLessonsApi", { enumerable: true, get: function () { return __importDefault(customLessonsApi_1).default; } });
